// @avantia common-code
import { HpMetaData } from '../engineClient/tools/clientAndServerUtilities';
import { HpClientAnswerMap, HpGlobalEngineState } from '../engineClient/types';
import { HpPoliciesState } from './policyTypes';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface HpGlobalState extends HpGlobalEngineState {
  policies: HpPoliciesState;
  claimEnquiryResult: HpClaimEnquiryResultState;
  user: HpUserState;
}

export interface HpCreatePostAnswersMiddlewareProps {
  websiteEndpoint: string;
}

export interface HpMiddlewareState {
  postedAnswers?: HpClientAnswerMap | undefined;
}

export interface HpUserState {
  name: string;
  email: string;
  sessionExpired?: boolean;
}

export interface WhatsNextItem {
  body: string;
  title: string;
}

export interface ClaimEnquiryResultCopyText {
  claimReferenceText: string;
  heading: string;
  saveClaimText?: string;
  subHeading: string;
  submissionType: 'claim' | 'enquiry' | undefined;
  whatsNextItems?: WhatsNextItem[];
}

export interface HpClaimEnquiryResultState extends ClaimEnquiryResultCopyText {
  claimReferenceNumber: string;
  claimJourneyComplete: boolean;
}

export interface HpClaimsMetaData extends HpMetaData {
  customerPortalAuthLink?: string; // TODO - Remove if not needed
  policyDetailsId?: string;
  historyId?: number;
  policyNumber?: string;
  claimEnquiryReference?: string; // DCJ reference, used for enquiries (Pre-Siteview)
  claimReference?: string; // Siteview external id.
  siteViewMeetingId?: string;
  perilTemplateInstanceId?: string; // Peril question set template, created at enquiry submit, filled in on peril submit.
}

/**
 * The two phases of a claim journey, named the way the question set names them in its own set-journey-phase
 * action. The `journeyPhase` answer holds one of these, and nothing else names a phase.
 */
export type HpJourneyPhase = 'Enquiry' | 'FNOL';

export const enquiryPhase: HpJourneyPhase = 'Enquiry';
export const fnolPhase: HpJourneyPhase = 'FNOL';
